import { TKV2_ORDER_PAIRED_COST_SETTINGS_API, Tkv2PairedCostSettings } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  PutTkv2OrderPairedCostSettingsAPIError,
  PutTkv2OrderPairedCostSettingsAPIVariables,
  fetchPutTkv2OrderPairedCostSettingsAPI,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_PAIRED_COST_SETTINGS_API.PUT;

export const usePutTkv2OrderPairedCostSettingsAPI = (
  options?: Omit<
    UseMutationOptions<
      Tkv2PairedCostSettings,
      PutTkv2OrderPairedCostSettingsAPIError,
      PutTkv2OrderPairedCostSettingsAPIVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<
    Tkv2PairedCostSettings,
    PutTkv2OrderPairedCostSettingsAPIError,
    PutTkv2OrderPairedCostSettingsAPIVariables
  >({
    mutationFn: (variables: PutTkv2OrderPairedCostSettingsAPIVariables) =>
      fetchPutTkv2OrderPairedCostSettingsAPI({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
